/**
 * B5: Conversation Inspector deep-link path.
 *
 * The full-page Conversation Inspector lives at the SPA route
 * `/analytics/conversations/:id` (rendered by Shell.jsx →
 * ConversationInspectorPage). The Supervisor "Conversations" tab already
 * deep-links there via `navigate(`/analytics/conversations/${c.id}`)`; this
 * helper is the single source of truth for that path so every
 * conversation-list surface (Supervisor rows + Analytics ES message results)
 * navigates identically.
 *
 * Guard: returns `null` when the id is missing / blank so callers can hide
 * the "Open in Inspector" affordance instead of routing to a broken
 * `/analytics/conversations/` (no id) URL.
 *
 * @param {string|null|undefined} conversationId
 * @returns {string|null} the inspector route, or null when there is no id.
 */
export function inspectorConversationPath(conversationId) {
  if (typeof conversationId !== "string") return null;
  const trimmed = conversationId.trim();
  if (!trimmed) return null;
  return `/analytics/conversations/${trimmed}`;
}
